import type { SvgIconProps } from 'types/icon';
import EventBusy from '@mui/icons-material/EventBusy';

export const EventBusyIcon = ({
  color = 'inherit',
  ...props
}: SvgIconProps) => <EventBusy color={color} {...props} />;
